export default "__VITE_PUBLIC_ASSET__29eef8c2__"